import { render, staticRenderFns } from "./PreorderList.vue?vue&type=template&id=8495ad6e&scoped=true&"
import script from "./PreorderList.vue?vue&type=script&lang=js&"
export * from "./PreorderList.vue?vue&type=script&lang=js&"
import style0 from "./PreorderList.vue?vue&type=style&index=0&id=8495ad6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495ad6e",
  null
  
)

export default component.exports